import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const pinGroups = gsap.utils.toArray(".pin-group");

gsap.set(pinGroups, { opacity: 0 });

gsap.to(pinGroups, {
    opacity: 1,
    duration: .4,
    ease: "linear",
    stagger: {
        each: 0.15,
        from: "random"
    },
    scrollTrigger: {
        trigger: ".coverage-map__map",
        start: "top 50%",
        once: true
    }
});
